
/**
 *
 *
 * Usage:
 *
 *   data-sw-login-link=<active signup tag> | optional
 *   data-sw-login-link-target-url=<target url> | optional – place to redirect after successful login
 *   data-sw-login-link-fragment=<fragment endpoint> | optional – fragment to display in login modal
 *   data-sw-login-link--internal-referrer=<internal referrer string> | optional - name used for referrer tracking
 *
 */

var SW = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');

$(document).ready(function() {

  $('body').on('click', '[data-sw-login-link]:not(form)', function(e) {
    if(SW.data.user.isLoggedIn){
      return;
    }
    var $el = $(e.currentTarget);

    var activeTab = $el.data('swLoginLink') || 'login';
    var internalReferrer = $el.data('swLoginLinkInternalReferrer');
    var referrer = $el.data('swLoginLinkReferrer') || $el.data('swLoginLinkTargetUrl') || window.location.href;


    var options = {};
    options.contentHref = $el.data('swLoginLinkFragment');

    if (signupDialog.openLogInSignUpDialog(activeTab, null, internalReferrer, null, referrer, options) === true) {
      e.preventDefault();
    }
  });

  $('body').on('click', '[data-sw-login-signup-toggle]', function(e){
    var $el = $(e.currentTarget);
    var activeTab = $el.data('swLoginSignupToggle');
    signupDialog.showLogInSignUpTab(activeTab);
    e.preventDefault();
  });

  $('body').on('submit', '[data-sw-login-link]', function(e) {

    var doneEvent = 'sw-login-complete';

    var $el = $(e.target);

    var activeTab = $el.data('swLoginLink') || 'login';
    var internalReferrer = $el.data('swLoginLinkInternalReferrer');
    var referrer = $el.data('swLoginLinkReferrer') || $el.data('swLoginLinkTargetUrl');

    var options = {};
    options.contentHref = $el.data('swLoginLinkFragment');
    options.doneEvent = doneEvent;

    if (signupDialog.openLogInSignUpDialog(activeTab, null, internalReferrer, null, referrer, options) === true) {
      e.preventDefault();
    }

    SW.once(doneEvent, function() {
      $el.removeAttr('data-sw-login-link');
      $el.trigger('submit');
    });

    e.preventDefault();
  });

});
